export default function BankOfAmericaIcon() {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect width="39.999" height="39.999" rx="8" fill="white" />
      <path
        d="M19.9519 28.6715C25.0045 24.3407 32.1023 20.1302 36 18.6144C35.3985 18.2294 34.4602 17.6761 33.4015 17.0746C28.373 18.7347 22.5023 22.4159 17.2572 26.5783C18.1474 27.252 19.0858 27.9497 19.9519 28.6715Z"
        fill="#E31837"
      />
      <path
        d="M17.6421 16.9061C16.8962 16.5452 16.0782 16.2084 15.4526 15.9197C13.5519 16.858 11.0737 18.2775 7.94587 20.5151C8.61956 20.876 9.34135 21.3091 10.1113 21.7422C12.5173 19.9618 14.9474 18.2775 17.6421 16.9061Z"
        fill="#012169"
      />
      <path
        d="M22.1412 14.837C21.2269 14.3317 18.051 13.1528 15.8615 12.6475C15.2119 12.8881 14.2976 13.249 13.672 13.5137C14.466 13.7302 17.4254 14.5242 19.9517 15.7994C20.6013 15.4866 21.5156 15.1017 22.1412 14.837Z"
        fill="#E31837"
      />
      <path
        d="M11.3864 14.5244C8.57142 15.8236 5.61203 17.6041 4 18.6386C4.57744 18.9033 5.15487 19.1198 5.94886 19.5048C9.50975 17.0988 12.3007 15.6311 13.4075 15.1499C12.6135 14.8612 11.8676 14.6687 11.3864 14.5244Z"
        fill="#012169"
      />
      <path
        d="M24.2587 14.0911C24.9083 13.8746 25.6542 13.6821 26.3038 13.4896C24.4271 12.6956 22.0692 11.8535 19.9519 11.3242C19.6151 11.4205 18.6046 11.6851 17.9068 11.9017C18.6286 12.1182 21.0106 12.6716 24.2587 14.0911ZM12.3971 23.1377C13.167 23.5949 13.985 24.2204 14.779 24.7498C20.0482 20.6595 25.2452 17.5077 30.9474 15.7272C30.1534 15.3182 29.4557 14.9573 28.5654 14.5242C25.1489 15.3904 19.3023 17.7242 12.3971 23.1377Z"
        fill="#E31837"
      />
    </svg>
  );
}
